import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { X } from 'lucide-react';
import { signalerMaj } from '../../lib/maj41';

/* LOT 41 · règle de toute l'app : l'action d'un autre module s'ouvre en pop-up par-dessus l'écran courant (même page, mêmes données) */
export const enPopup = () => { try { return window.self !== window.top || new URLSearchParams(window.location.search).get('popup') === '1'; } catch { return true; } };
const NOMS = { finance: 'Finance', achats: 'Achats', stock: 'Stock', hygiene: 'Hygiène', equipe: 'Équipe', recettes: 'Recettes', reservations: 'Réservations', communication: 'Communication', reglages: 'Réglages', accueil: 'Accueil', compte: 'Mon compte', recrutement: 'Recrutement' };

/* LOT 42 · KI2/KI3 · dans le pop-up, dès qu'une feuille du module s'ouvre, on n'affiche QUE cette feuille (jamais le module en miniature) ; elle fermée, le pop-up se ferme */
export const usePopupSeul = () => {
  useEffect(() => {
    if (!enPopup() || window.self === window.top) return undefined;
    let seul = false; let t = null;
    const n = () => document.querySelectorAll('.ig-overlay').length;
    const verifier = () => {
      if (n() > 0 && !seul) { seul = true; document.documentElement.classList.add('p42-seul'); window.parent.postMessage('popup41:seul', '*'); }
      if (seul && n() === 0) { clearTimeout(t); t = setTimeout(() => { if (n() === 0) window.parent.postMessage('popup41:fermer', '*'); }, 350); }
    };
    const mo = new MutationObserver(verifier); mo.observe(document.body, { childList: true });
    const plein = setTimeout(() => { if (!seul) window.parent.postMessage('popup41:module', '*'); }, 3500);
    verifier();
    return () => { mo.disconnect(); clearTimeout(t); clearTimeout(plein); };
  }, []);
};

export const PopupModuleHost = () => {
  const { tenantSlug: slug } = useParams();
  const [p, setP] = useState(null);
  const [etat, setEtat] = useState('attente');
  const nav = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);  // LOT 75 · une page ouverte depuis une carte commence en haut
  /* LOT 75 · jamais un module entier dans une fenêtre : la page d'un autre module s'ouvre en vraie page (‹ pour revenir) */
  useEffect(() => { const f = (e) => { const to = String(e.detail?.to || '').replace(/^\/+/, ''); if (to) nav(`/${slug}/${to}`); }; window.addEventListener('popup-module', f); return () => window.removeEventListener('popup-module', f); }, [nav, slug]);
  useEffect(() => {
    if (!p) return undefined;
    const f = (e) => { if (e.data === 'popup41:fermer') { setP(null); signalerMaj(); } if (e.data === 'popup41:seul') setEtat('seul'); if (e.data === 'popup41:module') setEtat((x) => (x === 'seul' ? x : 'module')); };
    const k = (e) => { if (e.key === 'Escape') { setP(null); signalerMaj(); } };
    window.addEventListener('message', f); window.addEventListener('keydown', k); return () => { window.removeEventListener('message', f); window.removeEventListener('keydown', k); };
  }, [p]);
  if (!p || enPopup()) return null;
  const src = `/${slug}/${p.to}${p.to.includes('?') ? '&' : '?'}popup=1`;
  const fermer = () => { setP(null); signalerMaj(); };
  const nom = NOMS[p.module] || p.to.split(/[/?]/)[0];
  return <div className={`p42-host is-${etat}`} onClick={fermer} data-testid="popup-module" data-etat={etat}>
    {etat === 'attente' && <div className="p42-charge" data-testid="popup-module-chargement"><i />{p.titre || nom}</div>}
    <div className="p42-carte" onClick={(e) => e.stopPropagation()}>
      <div className="p42-tete"><b data-testid="popup-module-titre">{p.titre || nom}</b><button type="button" onClick={fermer} title="Fermer" data-testid="popup-module-fermer"><X size={18} /></button></div>
      <iframe title={p.titre || nom} src={src} className="p41-frame" data-testid="popup-module-frame" />
      <p className="b41-source" data-testid="popup-module-source">Source : {nom}</p>
    </div>
  </div>;
};
